import { useContext } from 'react';
import { CompanySlugContext } from '../../providers/CompanySlugProvider';

export default function useCompanySlug() {
  return useContext(CompanySlugContext);
}
